var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detalhe-processo" },
    [
      !_vm.isCadastroPendente
        ? _c("el-row", [_c("cabecalho-processo")], 1)
        : _vm._e(),
      !_vm.isCadastroPendente
        ? _c("el-row", [_c("app-download-titulo")], 1)
        : _vm._e(),
      _c(
        "el-row",
        [
          _c("router-view", {
            attrs: { isCadastroPendente: _vm.isCadastroPendente }
          })
        ],
        1
      ),
      _vm.verificaBotaoAtivo()
        ? _c("app-cabecalho", {
            staticClass: "marginLeft",
            attrs: { titulo: "Voltar", route: "central/processos" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a1ba4ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a1ba4ef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/processos/DetalhesProcesso.vue
// module id = null
// module chunks = 